import { z } from "zod";

export const answerSubCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  is_checked: z.coerce.boolean(),
  question_count: z.number(),
});

export type AnswerSubCategory = z.infer<typeof answerSubCategorySchema>;
